<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    ModalPrint(v-show="modalStatus" :title="titleModal" :content="contentModal" :ruta="ruta" @imprimirPorte="regresarDocumentados")
    ModalUpdate(v-show="modalStatusUpd" :config="configModalUpd" @closeModalUpd="closeModalUpd")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Editar Carta Porte {{ editarEmb_IRGE.numeroDeEmbarque }}
        .columns
          .column.is-3
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Expendidor&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  Expendidor(:expendidor="expendidor")
          .column.is-5
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Destinatario&nbsp
                  span.tag.is-light {{ destino_sel.nombre }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TypeaheadDestinos(:options="destinosBD" :optionSelect="destino_sel" v-model="destino_sel" :isDisabled="isTH_disabled")
                  br
                  CardDestino(:destino="destino_sel" v-show="verCardDestino")
          .column.is-4
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Porteador&nbsp
                  span.tag.is-light {{ porteador_sel.nombre }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TypeaheadPorteadores(:options="porteadoresBD" :optionSelect="porteador_sel" v-model="porteador_sel" :isDisabled="isTH_disabled")
                  br
                  CardPorteador(:porteador="porteador_sel" v-show="verCardPorteador")
        .columns
          .column.is-6
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Datos de Facturación&nbsp
                  span.tag.is-light(v-show="isComplete_DatosFacturacion") Completos
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  .columns
                    .column.is-4
                      .field
                        .control
                          .select.is-primary
                            select(v-model="empresaSel" :disabled="isTH_disabled")
                              option(v-for="emp in empresas" :value="emp" ) {{ emp.nombre }}
                    .column.is-4
                      .field
                        .control
                          .select.is-primary
                            select(v-model="grupoSel" :disabled="isTH_disabled")
                              option(v-for="gr in grupos" :value="gr" ) {{ gr.nombre }}
                    .column.is-4
                      .field
                        .control
                          .select.is-primary
                            select(v-model="subGrupoSel" :disabled="isTH_disabled")
                              option(v-for="subG in subGrupos" :value="subG" ) {{ subG.nombre }}
          .column.is-6
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Datos del Tanque&nbsp
                  span.tag.is-light Datos Completos
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  .columns
                    TypeaheadOperadores(:options="operadoresBD" :optionSelect="operadorSel" v-model="operadorSel" :isDisabled="isTH_disabled")
                  .columns
                    .column
                      .field
                        label.label Placas
                          .control.has-icons-left.has-icons-right
                            input.input.is-primary(
                              type='text',
                              placeholder='Placas',
                              v-model="placas",
                              :disabled="isTH_disabled"
                            )
                    .column
                      .field
                        label.label Magnatel
                          .control.has-icons-left.has-icons-right
                            input.input.is-primary(
                              type='text',
                              placeholder='Magnatel',
                              v-model="magnatel",
                              :disabled="isTH_disabled"
                            )
                  .columns
                    .column
                      .field
                        label.label Presión
                          .control.has-icons-left.has-icons-right
                            input.input.is-primary(
                              type='text',
                              placeholder='Presión salida',
                              v-model="presionTanque",
                              :disabled="isTH_disabled"
                            )
                    .column
                      .field
                        label.label Sellos
                          .control.has-icons-left.has-icons-right
                            input.input.is-primary(
                              type='text',
                              placeholder='sellos',
                              v-model="sellos",
                              :disabled="isTH_disabled"
                            )
        .columns
          .column.is-6
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Datos Financieros&nbsp
                  span.tag.is-light {{ `Valor Unit. ${parseFloat(valores.valorUnitario).toFixed(2)}` }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  CardValores(:vu="valores")
          .column.is-6
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Autotanques Cargados&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  .columns
                    CardDatosCC_Edit(:carga="datosCargaBD" :valorUnitario="valores.valorUnitario" @cargaTotal="setCargaTotal" @contenidoLitros="setContenidoLitros")
        .columns.has-text-centered(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns.has-text-centered
          .column.is-offset-4.is-4
            span.tag.is-black {{ valorCargaTotal | currency }}
        .columns.has-text-centered
          .column.is-12
            a.button.is-warning.is-rounded(@click="editarCarta" v-show="!isEditando")
              | Editar
            | &nbsp
            a.button.is-light.is-rounded(@click="regresarDocumentados" v-show="!isEditando")
              | Regresar
            | &nbsp
            a.button.is-black.is-rounded(@click="checkFormularios" v-show="isEditando")
              | Actualizar
            | &nbsp
            a.button.is-light.is-rounded(@click="cancelEdit" v-show="isEditando")
              | Cancelar
      .columns.column-blanco
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/irge/NavBarSca.vue'
  import Expendidor from './Expendidor.vue'
  import TypeaheadDestinos from '../componentes/TypeaheadDestinos.vue'
  import TypeaheadPorteadores from '../componentes/TypeaheadPorteadores.vue'
  import TypeaheadOperadores from '../componentes/TypeaheadOperadores.vue'
  import ModalPrint from '../componentes/ModalPrint.vue'
  import ModalUpdate from '../componentes/ModalUpdate.vue'
  import TypeaheadPG from '../componentes/TypeaheadPG.vue'
  import CardPorteador from '../componentes/CardPorteador.vue'
  import CardDestino from '../componentes/CardDestino.vue'
  import CardValores from '../componentes/CardValores.vue'
  import CardDatosCC_Edit from '../componentes/CardDatosCC_Edit.vue'
  import Loader from '@/components/shared/Loader.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import sca_irgeServices from '@/services/sca/irge.js'

  export default {
    name: 'EditarEmbarque',
    components: { NavBarSca, Loader, BulmaAccordion, BulmaAccordionItem, TypeaheadDestinos, TypeaheadOperadores, TypeaheadPG, TypeaheadPorteadores, Expendidor, CardDestino, CardPorteador, CardValores, CardDatosCC_Edit, ModalPrint, ModalUpdate },
    data() {
      return {
        expendidor: {
          nombre: 'TERMIGAS S.A. DE C.V.(IRGE ATOTONILCO)',
          clave: 'TER-DO-EMB',
          telefono: '01 591 916 5373',
          direccion: 'CARR. JOROBAS-TULA KM. 10.5, EJIDO EL PEDREGAL, ATOTONILCO DE TULA HGO, C.P. 42980',
        },
        isLoading: true,
        porteadoresBD: [],
        porteador_sel: {},
        destinosBD: [],
        destino_sel: {},
        isTH_disabled: true,
        datosCargaBD: {},
        pgSel: {},
        operadoresBD: [],
        operadorSel: {},
        magnatel: null,
        placas: null,
        presionTanque: null,
        sellos: null,
        valores: {},
        verCardDestino: false,
        verCardPorteador: false,
        valorCargaTotal: 0,
        empresas: [],
        empresaSel: {},
        grupos: [],
        grupoSel: {},
        subGrupos: [],
        subGrupoSel: {},
        datosFaltantes: [],
        isComplete_DatosFacturacion: false,
        noEmbarque: '',
        fechaJornada: '',
        modalStatus: false,
        titleModal: '',
        contentModal: '',
        ruta: '',
        acceso: {},
        isEditando: false,
        isNormal: '',
        destinatario_old: {},
        porteador_old: {},
        operador_old: {},
        empresa_old: {},
        grupo_old: {},
        subgrupo_old: {},
        placas_old: '',
        magnatel_old: '',
        presionTanque_old: '',
        sellos_old: '',
        valorCarga_old: '',
        valorUnit_old: '',
        cambiosRealizados: [],
        modalStatusUpd: false,
        configModalUpd: {},
      }
    },
    watch: {
      porteador_sel() {
        if (Object.keys(this.porteador_sel).length > 0) {
          this.verCardPorteador = true
        } else {
          this.verCardPorteador = false
        }
      },
      destino_sel() {
        if (Object.keys(this.destino_sel).length > 0) {
          this.verCardDestino = true
        } else {
          this.verCardDestino = false
        }
      },
      empresaSel() {
        this.checkDatosFacturacion()
      },
      grupoSel() {
        this.checkDatosFacturacion()
      },
      subGrupoSel() {
        this.checkDatosFacturacion()
      },
      pgSel() {
        this.checkAcceso()
      }
    },
    methods: {
      iniciarComponente() {
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        let hoy = moment()
        let ahoraFinal = moment('05:15am', 'h:mma')
        this.valorCargaTotal = this.editarEmb_IRGE.valorCarga
        this.placas = this.editarEmb_IRGE.placas
        this.presionTanque = this.editarEmb_IRGE.presionTanque
        this.sellos = this.editarEmb_IRGE.datosAdicionales
        this.empresaSel = this.empresas.find( emp => emp.id === parseInt(this.editarEmb_IRGE.compania))
        this.grupoSel = this.grupos.find( gru => gru.id === parseInt(this.editarEmb_IRGE.grupo))
        this.subGrupoSel = this.subGrupos.find( sub => sub.id === this.editarEmb_IRGE.subgrupo )
        this.magnatel = this.editarEmb_IRGE.magnatel

        if (ahoraFinal.isBefore(ahora)) {
          this.fechaJornada = hoy.format('YYYY-MM-DD')
        } else {
          this.fechaJornada = hoy.subtract(1, 'days').format('YYYY-MM-DD')
        }
        this.obtenerPorteadores()
      },
      obtenerPorteadores () {
        sca_irgeServices.getPorteadores()
          .then(resPort => {
            this.porteadoresBD = resPort
            this.porteador_sel = this.porteadoresBD.find( port => port.id === this.editarEmb_IRGE.idporteador)
            this.obtenerDestinatarios()
          })
          .catch(e => console.log(e))
      },
      obtenerDestinatarios () {
        sca_irgeServices.getDestinos()
          .then(resPort => {
            this.destinosBD = resPort
            this.destino_sel = this.destinosBD.find( dest => dest.idDestinatario === this.editarEmb_IRGE.iddestinatario)
            this.obtenerOperadores()
          })
          .catch(e => console.log(e))
      },
      obtenerOperadores () {
        sca_irgeServices.getOperadores()
          .then(resOper => {
            //console.log(resOper)
            this.operadoresBD = resOper
            this.operadorSel = this.operadoresBD.find( oper => oper.nombre === this.editarEmb_IRGE.operador)
//            this.obtenerValorUnitario()
            this.obtenerDatosCarga()
          })
          .catch(e => console.log(e))
      },
      obtenerValorUnitario () {
        console.log('onter valor unitario')
        sca_irgeServices.getValorUnitario()
          .then( res => {
            //console.log(res)
            this.valores = res[0]
            this.destinatario_old = this.destino_sel
            this.porteador_old = this.porteador_sel
            this.operador_old = this.operadorSel
            this.empresa_old = this.empresaSel
            this.grupo_old = this.grupoSel
            this.subgrupo_old = this.subGrupoSel
            this.placas_old = this.placas
            this.magnatel_old = this.magnatel
            this.presionTanque_old = this.presionTanque
            this.sellos_old = this.sellos
            this.valorCarga_old = this.valorCargaTotal
            this.valorUnit_old = this.valores.valorUnitario
          })
          .catch(e => console.log(e))
      },
      obtenerDatosCarga () {
        sca_irgeServices.getEmbarque(this.editarEmb_IRGE.noEmbarque)
          .then(res => {
            //console.log(res)
            this.datosCargaBD = res[0]
            this.obtenerValorUnitario()
          })
          .catch(e => console.log(e))
        this.isLoading = false
      },
      setCargaTotal (val) {
        //console.log(val)
        this.valorCargaTotal = val
      },
      setContenidoLitros (val) {
        this.setContenidoLitros = val
      },
      checkFormularios () {
        this.datosFaltantes = []
        // if (Object.keys(this.destino_sel).length > 1 || Object.keys(this.porteador_sel).length) {
        if (Object.keys(this.destino_sel).length >= 1 && Object.keys(this.porteador_sel).length >= 1 && Object.keys(this.empresaSel).length >= 1 && Object.keys(this.grupoSel).length >= 1 && Object.keys(this.subGrupoSel).length >= 1 && Object.keys(this.operadorSel).length >= 1 && this.magnatel && this.placas && this.presionTanque && this.sellos) {
          this.checkCambios()
        } else {

          if (Object.keys(this.destino_sel).length == 0) {
            this.datosFaltantes.push('El destino es requerido.')
          }
          if (Object.keys(this.porteador_sel).length == 0) {
            this.datosFaltantes.push('El porteador es requerido.')
          }
          if (Object.keys(this.empresaSel).length == 0) {
            this.datosFaltantes.push('La Empresa es requerida.')
          }
          if (Object.keys(this.grupoSel).length == 0) {
            this.datosFaltantes.push('El grupo es requerido.')
          }
          if (Object.keys(this.subGrupoSel).length == 0) {
            this.datosFaltantes.push('El subgrupo es requerido.')
          }
          if (Object.keys(this.operadorSel).length == 0) {
            this.datosFaltantes.push('El Operador es requerido.')
          }
          if (!this.magnatel) {
            this.datosFaltantes.push('El magnatel es requerido.')
          }
          if (!this.placas) {
            this.datosFaltantes.push('Las placas son requeridos.')
          }
          if (!this.presionTanque) {
            this.datosFaltantes.push('La Presión de salida es requerida.')
          }
          if (!this.sellos) {
            this.datosFaltantes.push('Los sellos son requeridos.')
          }
        }
      },
      checkCambios () {
        this.cambiosRealizados = []
        if (this.destino_sel.idDestinatario !== this.destinatario_old.idDestinatario) {
          this.cambiosRealizados.push(`Id Destinatario: id Ant.: ${this.destinatario_old.idDestinatario} - Id. Nuevo: ${this.destino_sel.idDestinatario} | `)
          this.cambiosRealizados.push(`Destinatario: Ant.: ${this.destinatario_old.nombre} - Nuevo: ${this.destino_sel.nombre} | `)
        }
        if (this.porteador_sel.id !== this.porteador_old.id) {
          this.cambiosRealizados.push(`Id Porteador: id Ant.: ${this.porteador_old.id} - Id. Nuevo: ${this.porteador_sel.id} | `)
          this.cambiosRealizados.push(`Porteador: Ant.: ${this.porteador_old.nombre} - Nuevo: ${this.porteador_sel.nombre} | `)
        }

        if (this.operadorSel.id !== this.operador_old.id) {
          this.cambiosRealizados.push(`Id Operador: id Ant.: ${this.operador_old.id} - Id. Nuevo: ${this.operadorSel.id} | `)
          this.cambiosRealizados.push(`Operador: Ant.: ${this.operador_old.nombre} - Nuevo: ${this.operadorSel.nombre} | `)
        }

        if (this.placas_old !== this.placas) {
          this.cambiosRealizados.push(`Placas: Ant.: ${this.placas_old} - Nuevas: ${this.placas} | `)
        }

        if (this.magnatel_old !== this.magnatel) {
          this.cambiosRealizados.push( `magnatel: Ant.: ${this.magnatel_old} - Nuevas: ${this.magnatel} | `)
        }

        if (this.presionTanque_old !== this.presionTanque) {
          this.cambiosRealizados.push(`presionTanque: Ant.: ${this.presionTanque_old} - Nuevas: ${this.presionTanque} | `)
        }

        if (this.sellos_old !== this.sellos) {
          this.cambiosRealizados.push(`sellos: Ant.: ${this.sellos_old} - Nuevas: ${this.sellos} | `)
        }

        if (this.empresaSel.id !== this.empresa_old.id) {
          this.cambiosRealizados.push(`Id empresa: id Ant.: ${this.empresa_old.id} - Id. Nuevo: ${this.empresaSel.id} | `)
          this.cambiosRealizados.push(`empresa: Ant.: ${this.empresa_old.nombre} - Nuevo: ${this.empresaSel.nombre} | `)
        }

        if (this.grupoSel.id !== this.grupo_old.id) {
          this.cambiosRealizados.push(`Id grupo: id Ant.: ${this.grupo_old.id} - Id. Nuevo: ${this.grupoSel.id} | `)
          this.cambiosRealizados.push(`grupo: Ant.: ${this.grupo_old.nombre} - Nuevo: ${this.grupoSel.nombre} | `)
        }

        if (this.subGrupoSel.id !== this.subgrupo_old.id) {
          this.cambiosRealizados.push(`Id subGrupo: id Ant.: ${this.subgrupo_old.id} - Id. Nuevo: ${this.subGrupoSel.id} | `)
          this.cambiosRealizados.push(`subGrupo: Ant.: ${this.subgrupo_old.nombre} - Nuevo: ${this.subGrupoSel.nombre} | `)
        }

        if (this.valorCargaTotal !== this.valorCarga_old) {
          this.cambiosRealizados.push(`ValorCarga: Ant.: ${this.valorCarga_old} - Nuevas: ${this.valorCargaTotal} | `)
        }

        if (this.valores.valorUnitario !== this.valorUnit_old) {
          this.cambiosRealizados.push(`Valor Unitario: Ant.: ${this.valorUnit_old} - Nuevas: ${this.valores.valorUnitario} | `)
        }

        this.guardarEmbarque()
      },
      checkDatosFacturacion () {
        if ( Object.keys(this.empresaSel).length >= 1 && Object.keys(this.grupoSel).length >= 1 && Object.keys(this.subGrupoSel).length >= 1 ) {
          this.isComplete_DatosFacturacion = true
        } else {
          this.isComplete_DatosFacturacion = false
        }
      },
      guardarEmbarque () {
        sca_irgeServices.updateCartaPorte(this.editarEmb_IRGE.id,this.destino_sel.idDestinatario, this.destino_sel.nombre, this.destino_sel.clave, this.destino_sel.direccion, this.destino_sel.telefono, this.porteador_sel.id, this.porteador_sel.nombre, this.porteador_sel.clave, this.porteador_sel.rfc, this.placas, this.operadorSel.nombre, this.empresaSel.id, this.grupoSel.id, this.subGrupoSel.id, this.magnatel, this.sellos, this.operadorSel.nombre, this.presionTanque, this.valorCargaTotal, this.valores.valorUnitario)
          .then( resp => {
            //console.log(resp)
            if (resp.success) {
              let texto = ''
              this.cambiosRealizados.forEach(cambioR => {
                texto += `${cambioR}`
              })
              console.log(texto)
              let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
              sca_irgeServices.addEdicion(this.editarEmb_IRGE.id, ahora, this.userLogin.nombre, texto)
                .then(resAE => {
                  console.log(resAE)
                  if (resAE.success) {
                    this.verModalUpdate()
                  } else {
                    let toast = this.$toasted.show(`Error: ${resAE.respuesta}`, {
                      theme: "toasted-primary",
                      position: "bottom-right",
                      duration : 3000,
                      iconPack: 'fontawesome',
                      icon: 'ban',
                      action : {
                        text : 'Ok',
                        onClick : (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                    })
                  }
                })
                .catch(e => console.log(e))

            } else {
              let toast = this.$toasted.show(`Error: ${resp.respuesta}`, {
                theme: "toasted-primary",
                position: "bottom-right",
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch(e1 => console.log(e1))
      },
      checkAcceso () {
        sca_irgeServices.getAcceso_pg(this.pgSel.pg)
          .then(data => {
            console.log(data[0])
            if (data.length < 1) {
              this.acceso = {}
            } else {
              this.acceso = data[0]
            }
          })
          .catch(e => console.log(e))
      },
      verModalImprmir () {
        const currentUrl = window.location.hostname
        const protocol = window.location.protocol
        console.log(currentUrl)
        this.ruta = `${protocol}//${currentUrl}/servidores/reportes/cartaPorte_Irge.php?emb=${this.editarEmb_IRGE.noEmbarque}&n=${this.editarEmb_IRGE.numeroDeEmbarque}`
        console.log(this.ruta)
        this.titleModal = 'Imprimir Carta Porte'
        this.contentModal = `EL embarque ${this.noEmbarque} ha sido registrado exitosamente.`
        this.modalStatus = true
      },
      regresarDocumentados () {
        this.modalStatus = false
        this.$store.commit('editarEmb_IRGE', {})
        this.$router.push('/IRGE/SCA/Documentacion')
      },
      editarCarta () {
        this.isEditando = true
        this.isTH_disabled = false
      },
      cancelEdit () {
        this.isEditando = false
        this.isTH_disabled = true
      },
      verModalUpdate () {
        this.configModalUpd = {
          title: 'Motivo Actualización',
          content: 'Escriba el motivo de la actualización.',
          question: 'Motivo',
          textOk: 'Guardar',
        }
        this.modalStatusUpd = true

      },
      closeModalUpd (res) {
        this.modalStatusUpd = false
        sca_irgeServices.updateMotivo(res.valor, this.editarEmb_IRGE.id)
          .then( data => {
            if (data.success) {
              this.verModalImprmir()
            } else {
              let toast = this.$toasted.show(`Error: ${data.respuesta}`, {
                theme: "toasted-primary",
                position: "bottom-right",
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch( e => {
            console.log(e.message)
          })
      },
      obtenerEmpresas(){
        sca_irgeServices.getEmpresasIRGE()
          .then((data) => {
            this.empresas = data
            this.obtenerGrupos()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
      obtenerGrupos(){
        sca_irgeServices.getGruposIRGE()
          .then((data) => {
            this.grupos = data
            this.obtenerSubgrupos()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
      obtenerSubgrupos(){
        sca_irgeServices.getSubgruposIRGE()
          .then((data) => {
            this.subGrupos = data
            this.iniciarComponente()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
    },
    created () {
      this.obtenerEmpresas()
    },
      computed: {
      ...mapState(['logueado', 'userLogin', 'editarEmb_IRGE'])
  }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/EditarEmbarque.vue